import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a file with down arrow icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/file-arrow-down?f=classic&s=solid
 */
export const FileArrowDownIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faFileArrowDown} {...props} />;
};
